import * as React from "react";
import SearchResults, { SearchResultsProps } from "~/components/search-results/search-results";

interface ISearchResultsViewProps {
    contextModel: SearchResultsProps;
}

class SearchResultsView extends React.Component<ISearchResultsViewProps> {
    public render() {
        return <SearchResults {...this.props.contextModel} />;
    }
}

export default SearchResultsView;
